<template>
  <div>
    <div class="flex flex-col">
      <div
        v-show="listOfExpiredContract.length"
        class="mb-5 bg-contract-banner"
      >
        <div class="flex flex-row items-center bg-white rounded-2xl">
          <img :src="require('../../../assets/shipo-icon-calendar-expired.svg')">
        </div>
        <span class="ml-3 font-semibold">{{ handleContractBannerWord() }}</span>
        <div
          class="px-5 py-3 ml-auto font-semibold text-secondary bg-white rounded-lg cursor-pointer"
          @click="onBannerClick('contract')"
        >
          See {{ listOfExpiredContract.length }} More
        </div>
      </div>
      <div
        v-show="listOfExpiredCertificate.length"
        class="bg-certificate-banner"
        :class="{'mb-5': listOfExpiredContract.length}"
      >
        <div class="flex flex-row items-center bg-white rounded-2xl">
          <img :src="require('../../../assets/shipo-icon-calendar-expired.svg')">
        </div>
        <span class="ml-3 font-semibold">{{ handleCertificateBannerWord() }}</span>
        <div
          class="px-5 py-3 ml-auto font-semibold text-secondary bg-white rounded-lg cursor-pointer"
          @click="onBannerClick('certificate')"
        >
          See Certificate
        </div>
      </div>
      <p class="font-semibold text-3xl">
        List Contract Management
      </p>
      <vs-row
        vs-w="12"
        class="my-5 filter-container"
      >
        <vs-col vs-w="1">
          <p class="font-semibold">
            Filter
          </p>
        </vs-col>
        <vs-col vs-w="2">
          <select-with-search
            hide-search
            v-model="filter.type"
            class="px-2"
            :options="charterTypes"
          />
        </vs-col>
        <vs-col vs-w="2">
          <select-with-search
            hide-search
            v-model="filter.under_company"
            placeholder="Select under company"
            class="px-2"
            :disabled="filter.type === 'SPOT'"
            :options="underCompanyOptions"
          />
        </vs-col>
        <vs-col vs-w="2">
          <select-with-search
            hide-search
            v-model="filter.contractor"
            placeholder="Select contractor"
            class="px-2"
            :options="contractorOptions"
          />
        </vs-col>
        <vs-col vs-w="2">
          <date-picker
            v-model="filter.contract_start"
            type="date"
            format="DD-MMM-YYYY"
            placeholder="Contract start"
            class="px-2 min-w-full"
          />
        </vs-col>
        <vs-col vs-w="2">
          <date-picker
            v-model="filter.contract_end"
            type="date"
            format="DD-MMM-YYYY"
            placeholder="Contract end"
            class="px-2 min-w-full"
          />
        </vs-col>
        <vs-col vs-w="1">
          <vs-button
            type="filled"
            color="primary"
            class="w-full font-semibold text-white"
            @click="fetchContracts"
          >
            Filter
          </vs-button>
        </vs-col>
      </vs-row>
      <div>
        <div>
          <table-top
            :page-size-start="false"
            @fetch="fetchContracts"
          >
            <template #start>
              <div class="select-container">
                <vs-button
                  v-show="isUserCanAccessMenu(permission.name, 'add')"
                  type="filled"
                  color="primary"
                  class="w-48 font-semibold"
                  @click="isCharterOptionShown = !isCharterOptionShown"
                >
                  Add Contract
                </vs-button>
                <div
                  v-if="isCharterOptionShown"
                  class="bg-option-container"
                >
                  <ul>
                    <li
                      v-for="(item, index) of filterCharterForCreateOption()"
                      class="my-1"
                      :key="index"
                      @click="goToCreatePage(item)"
                    >
                      <span>{{ item.text }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </table-top>
          <data-table
            class="my-5"
            :table-header="generateHeaderByCharterType()"
            :table-data="contractData"
          >
            <template #action="{ row }">
              <div class="w-24 flex flex-row">
                <div
                  class="mr-1 flex flex-col justify-center cursor-pointer icon-transparent-bg"
                  @click="goToDetailPage(row)"
                >
                  <img :src="require('@/assets/shipo-icon-see.svg')">
                </div>
                <div
                  v-if="row.contract_status !== 'terminate' && isUserCanAccessMenu(permission.name, 'edit')"
                  class="ml-1 flex flex-col justify-center cursor-pointer icon-transparent-bg"
                  @click="goToEditPage(row)"
                >
                  <img :src="require('@/assets/shipo-icon-edit.svg')">
                </div>
              </div>
            </template>
            <template #contract_start="{ row }">
              <span>{{ row.contract_start
                ? moment(row.contract_start, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD-MMM-YYYY')
                : '-'
              }}</span>
            </template>
            <template #contract_end="{ row }">
              <span>{{ row.contract_end
                ? moment(row.contract_end, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD-MMM-YYYY')
                : '-'
              }}</span>
            </template>
            <template #rent_price="{ row }">
              <span v-html="getCurrencySymbol(row.currency)" />
              <span>
                {{ 
                  !row.rent_price 
                    ? '-' 
                    : row.rent_price.toLocaleString(row.currency.currency_code === 'IDR' 
                      ? 'id-ID' 
                      : 'en-US' )
                }}
              </span>
            </template>
            <template #currence="{ row }">
              <span>
                {{
                  !row.currency 
                    ? '-' 
                    : row.currency.currency_code === 'IDR' 
                      ? '-' 
                      : !row.currence 
                        ? '-' 
                        : row.currence.toLocaleString('id-ID')
                }}
              </span>
            </template>
            <template
              v-if="filter.type === 'ALL' || filter.type === 'TIME'"
              #doc_status="{ row }"
            >
              <span
                class="bg-doc"
                :class="[row.doc_status ? (row.doc_status === 'complete' ? 'bg-complete-doc' : 'bg-incomplete-doc') : '']"
              >
                {{ row.doc_status ? upperFirst(row.doc_status) : '-' }}
              </span>
            </template>
            <template #contract_status="{ row }">
              <span
                :class="[row.contract_status ? (lowerCase(row.contract_status) === 'active' ? 'bg-contract-active' : 'bg-contract-terminated') : '']"
              >
                {{ row.contract_status ? startCase(row.contract_status) : '-' }}
              </span>
            </template>
          </data-table>
          <table-bottom @fetch="fetchContracts" />
        </div>
      </div>
    </div>
    <base-custom-modal :is-shown.sync="isExpiredModalShown">
      <template #title>
        <span class="font-semibold text-xl">List of expired {{ expiredType }}</span>
      </template>
      <template #body>
        <div class="flex flex-col">
          <div
            v-for="(item, index) of expiredType === 'contract' ? listOfExpiredContract : listOfExpiredCertificate"
            class="p-3 mb-3 flex flex-row items-center bg-white rounded-lg"
            :key="index"
          >
            <img
              :src="require('../../../assets/shipo-icon-calendar-expired.svg')"
              class="mr-3 bg-incomplete-doc rounded-xl"
            >
            <p class="mr-2">
              <span>{{ expiredType === 'contract'
                ? handleContractMessage(item.type, item.contractor, item.contract_end).message
                : handleCertificateMessage(item.type, item.barge_tug_name, item.name, item.valid).message
              }}
              </span>
              <span class="font-semibold text-danger">{{ expiredType === 'contract'
                ? handleContractMessage(item.type, item.contractor, item.contract_end).expiredDay
                : handleCertificateMessage(item.type, item.barge_tug_name, item.name, item.valid).expiredDay
              }}
              </span>
            </p>
            <vs-button
              v-show="isUserCanAccessMenu(permission.name, 'edit')"
              type="filled"
              color="secondary"
              class="ml-auto font-semibold"
              @click="expiredType === 'contract' ? goToContract(item) : goToCertificate(item)"
            >
              {{ expiredType === 'contract' ? 'See Contract' : 'See Certificate' }}
            </vs-button>
          </div>
        </div>
      </template>
    </base-custom-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseCustomModal from '@/components/baseCustomModal'
import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import SelectWithSearch from '@/components/selectWithSearch'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'

export default {
  metaInfo: {
    title: `${PAGE_TITLE} Contract Management`
  },
  components: {
    BaseCustomModal,
    DataTable,
    DatePicker,
    SelectWithSearch,
    TableBottom,
    TableTop
  },
  data() {
    return {
      isCharterOptionShown: false,
      isExpiredModalShown: false,
      expiredType: null,
      filter: {
        type: 'ALL',
        under_company: null,
        contractor: null,
        contract_start: null,
        contract_end: null
      },
      charterTypes: [
        { value: 'ALL', text: 'All' },
        { value: 'TIME', text: 'Time Charter' },
        { value: 'SPOT', text: 'Spot Charter' }
      ],
      contractHeaders: [
        { key: 'action', label: 'Action' },
        { key: 'type', label: 'Lease Base', sortable: true },
        { key: 'under_company', label: 'Under Company', sortable: true },
        { key: 'barge_size', label: 'Barge Size', sortable: true },
        { key: 'route', label: 'Route', sortable: true },
        { key: 'contractor', label: 'Contractor', sortable: true },
        { key: 'contract_start', label: 'Contract Start', sortable: true },
        { key: 'contract_end', label: 'Contract End', sortable: true },
        { key: 'contract_number', label: 'Contract Number', sortable: true },
        { key: 'rent_price', label: 'Rent Price', sortable: true },
        { key: 'currence', label: 'Currency', sortable: true },
        { key: 'doc_status', label: 'Doc Status', sortable: true },
        { key: 'contract_status', label: 'Contract Status', sortable: true }
      ],
      contractData: [],
      listOfExpiredContract: [],
      listOfExpiredCertificate: [],
      underCompanyOptions: [],
      contractorOptions: []
    }
  },
  computed: {
    ...mapGetters({
      contractItems: 'Contract/contracts',
      underCompanies: 'Contract/underCompanies',
      contractors: 'Contract/contractors',
      contractNotifications: 'Contract/contractNotifications',
      certificateNotifications: 'Contract/certificateNotifications'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    contractItems: {
      handler(val) {
        this.contractData = val
      }
    },
    underCompanies: {
      handler(val) {
        this.underCompanyOptions = val.map(item => ({ value: item.name, text: item.name }))
      }
    },
    contractors: {
      handler(val) {
        this.contractorOptions = val.map(item => ({ value: item.name, text: item.name }))
      }
    },
    contractNotifications: {
      handler(val) {
        this.listOfExpiredContract = val
      }
    },
    certificateNotifications: {
      handler(val) {
        this.listOfExpiredCertificate = val
      }
    }
  },
  mounted() {
    this.fetchUnderCompanies()
    this.fetchContractors()
    this.fetchContractNotifications()
    this.fetchCertificateNotifications()
  },
  methods: {
    async fetchContracts() {
      await this.$store.dispatch('Contract/fetchContracts', this.filter)
    },
    async fetchUnderCompanies() {
      await this.$store.dispatch('Contract/fetchMasters', 'under_company')
    },
    async fetchContractors() {
      await this.$store.dispatch('Contract/fetchMasters', 'contractor')
    },
    async fetchContractNotifications() {
      await this.$store.dispatch('Contract/fetchContractNotifications')
    },
    async fetchCertificateNotifications() {
      await this.$store.dispatch('Contract/fetchCertificateNotifications')
    },
    generateHeaderByCharterType() {
      switch (this.filter.type) {
        case 'TIME':
          return this.contractHeaders.filter(item => item.key !== 'route')
        case 'SPOT':
          return this.contractHeaders.filter(item => item.key !== 'under_company')
        default:
          return this.contractHeaders
      }
    },
    filterCharterForCreateOption() {
      return this.charterTypes.filter(item => item.value !== 'ALL')
    },
    goToCreatePage(item) {
      this.$store.dispatch('Contract/setCharterType', item.value)
      this.$router.push({ name: 'ContractManagementCreate' })
    },
    goToDetailPage(item) {
      this.$store.dispatch('Contract/setCharterType', item.type)
      this.$router.push({ name: 'ContractManagementDetail', params: { id: item.id } })
    },
    goToEditPage(item) {
      this.$store.dispatch('Contract/setCharterType', item.type)
      this.$router.push({ name: 'ContractManagementEdit', params: { id: item.id } })
    },
    handleContractBannerWord() {
      return `There ${this.listOfExpiredContract.length === 1 ? 'is' : 'are'} ${this.listOfExpiredContract.length}
        contract(s) that will be expired soon`
    },
    handleCertificateBannerWord() {
      return `There ${this.listOfExpiredCertificate.length === 1 ? 'is' : 'are'} ${this.listOfExpiredCertificate.length}
        certificate(s) that will be expired soon`
    },
    handleContractMessage(type, contractor, expiredDate) {
      const dayToExpire = this.moment(expiredDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ').diff(this.moment(), 'days')
      return {
        message: `Contract ${this.upperFirst(type)} Charter - ${contractor} Will Be Expired ${dayToExpire ? 'In' : ''}`,
        expiredDay: dayToExpire ? `${dayToExpire + 1} Day(s)` : 'Tomorrow'
      }
    },
    handleCertificateMessage(type, contractor, certificateName, expiredDate) {
      const dayToExpire = this.moment(expiredDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ').diff(this.moment(), 'days')
      return {
        message: `Certificate ${this.upperFirst(type)} - ${contractor} - ${certificateName} Will Be Expired ${dayToExpire ? 'In' : ''}`,
        expiredDay: dayToExpire ? `${dayToExpire + 1} Day(s)` : 'Tomorrow'
      }
    },
    onBannerClick(type) {
      this.expiredType = type
      this.isExpiredModalShown = true
    },
    getCurrencySymbol(val) {
      if (!val) {
        return ''
      }
      
      switch (this.lowerCase(val.currency_code)) {
        case 'idr':
          return 'Rp. '
        case 'eur':
          return '&euro;'
        default:
          return '&dollar;'
      }
    },
    goToContract(item) {
      this.$store.dispatch('Contract/setCharterType', item.type)
      this.$router.push({ name: 'ContractManagementEdit', params: { id: item.id } })
    },
    goToCertificate(item) {
      if (item.type === 'barge') {
        this.$router.push({ name: 'ContractManagementEditBargeCertificate', params: { id: item.id } })
        return
      }

      this.$router.push({ name: 'ContractManagementEditTugCertificate', params: { id: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  @apply p-3 rounded-lg cursor-pointer;

  color: #3D3D3D;

  &:hover {
    @apply font-semibold;

    background-color: #F1F1FD;
    color: #6546C3;
  }
}

.filter-container {
  @apply p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
}

.select-container {
  @apply relative;
}

.bg-option-container {
  @apply p-3 mt-1 w-full flex flex-col absolute bg-white rounded-lg shadow-lg;

  max-height: 20rem;
  z-index: 1000;
}

.bg-doc {
  @apply px-3 py-1 font-semibold rounded-lg;
}

.bg-complete-doc {
  @apply text-success;

  background-color: rgba(#00C48C, 0.15);
}

.bg-incomplete-doc {
  @apply text-danger;

  background-color: rgba(#FF647C, 0.15);
}

.bg-contract-active {
  @apply py-1 px-3 text-primary font-semibold rounded-lg;

  background-color: #F1F1FD;
}

.bg-contract-terminated {
  @apply py-1 px-3 text-danger bg-danger-accent font-semibold rounded-lg;
}

.bg-contract-banner {
  @apply p-5 w-full flex flex-row items-center text-white;

  background-image: url("../../../assets/shipo-banner-contract-bg.svg");
  background-size: cover;
}

.bg-certificate-banner {
  @apply p-5 w-full flex flex-row items-center text-white;

  background-image: url("../../../assets/shipo-banner-certificate-bg.svg");
  background-size: cover;
}

/deep/.modal-content-container {
  @apply w-2/4 h-auto;
}
</style>
